import { Stack, Avatar, Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { MD5 } from "../../../../../../../utility/md5";
type UserCellProps = {
  params: GridRenderCellParams;
};
export const UserCell = ({
  params
}: UserCellProps) => {
  if (!params?.row?.meta?.createdByUserName) return <></>;
  return <Stack direction="row" gap={1.5} alignItems="center" height="100%" data-sentry-element="Stack" data-sentry-component="UserCell" data-sentry-source-file="UserCell.tsx">
      <Avatar alt={params?.row?.meta?.createdByUserName} src={`https://www.gravatar.com/avatar/${MD5(params?.row?.meta?.createdByUserEmail || "")}?s=32`} sx={{
      width: 32,
      height: 32
    }} data-sentry-element="Avatar" data-sentry-source-file="UserCell.tsx" />
      <Typography variant="body2" data-sentry-element="Typography" data-sentry-source-file="UserCell.tsx">
        {params?.row?.meta?.createdByUserName}
      </Typography>
    </Stack>;
};